import { render, staticRenderFns } from "./LinhaSubitem.vue?vue&type=template&id=39433228&scoped=true"
import script from "./LinhaSubitem.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhaSubitem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhaSubitem.vue?vue&type=style&index=0&id=39433228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39433228",
  null
  
)

export default component.exports